// extracted by mini-css-extract-plugin
export default {"form":"_1Scn1___EditListing-module__form"};